import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, createBlock as _createBlock, vModelSelect as _vModelSelect, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = ["action"]
const _hoisted_2 = ["value"]
const _hoisted_3 = { class: "translation-progress" }
const _hoisted_4 = { class: "translation-progress-bar" }
const _hoisted_5 = { class: "translation-progress-label" }
const _hoisted_6 = { class: "translation-editor" }
const _hoisted_7 = { class: "editor-panel source-panel" }
const _hoisted_8 = { class: "panel-header" }
const _hoisted_9 = { class: "badge badge-info" }
const _hoisted_10 = { class: "panel-content" }
const _hoisted_11 = { class: "form-group" }
const _hoisted_12 = ["value"]
const _hoisted_13 = {
  key: 0,
  class: "form-group"
}
const _hoisted_14 = {
  class: "form-control",
  rows: "4",
  disabled: ""
}
const _hoisted_15 = {
  key: 0,
  class: "form-control",
  rows: "3",
  disabled: ""
}
const _hoisted_16 = ["value"]
const _hoisted_17 = { class: "editor-panel translation-panel" }
const _hoisted_18 = { class: "panel-header" }
const _hoisted_19 = { class: "badge badge-type" }
const _hoisted_20 = { class: "panel-content" }
const _hoisted_21 = { class: "form-group field-translated" }
const _hoisted_22 = { for: "content_name" }
const _hoisted_23 = {
  key: 0,
  class: "form-group"
}
const _hoisted_24 = { class: "form-help" }
const _hoisted_25 = ["for"]
const _hoisted_26 = ["id", "onUpdate:modelValue", "name"]
const _hoisted_27 = ["id", "onUpdate:modelValue", "name"]
const _hoisted_28 = { class: "form-group" }
const _hoisted_29 = { for: "content_status" }
const _hoisted_30 = { value: "draft" }
const _hoisted_31 = { value: "pending_review" }
const _hoisted_32 = { value: "published" }
const _hoisted_33 = { class: "form-actions" }
const _hoisted_34 = ["href"]
const _hoisted_35 = {
  type: "submit",
  class: "btn btn-primary"
}
const _hoisted_36 = {
  type: "submit",
  name: "content[status]",
  value: "pending_review",
  class: "btn btn-warning"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("form", {
    action: $props.formAction,
    method: "post",
    class: "translation-edit-form",
    onSubmit: $setup.onSubmit
  }, [
    _createElementVNode("input", {
      type: "hidden",
      name: "authenticity_token",
      value: $props.csrfToken
    }, null, 8 /* PROPS */, _hoisted_2),
    _cache[3] || (_cache[3] = _createElementVNode("input", {
      type: "hidden",
      name: "_method",
      value: "patch"
    }, null, -1 /* CACHED */)),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", {
          class: "translation-progress-fill",
          style: _normalizeStyle({ width: `${$setup.progress.percent}%` })
        }, null, 4 /* STYLE */)
      ]),
      _createElementVNode("span", _hoisted_5, _toDisplayString($setup.label("progress", "Translation progress")) + ": " + _toDisplayString($setup.progress.completed) + " / " + _toDisplayString($setup.progress.total) + " (" + _toDisplayString($setup.progress.percent) + "%) ", 1 /* TEXT */)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("h2", null, _toDisplayString($setup.label("sourceTitle", "German (Source)")), 1 /* TEXT */),
          _createElementVNode("span", _hoisted_9, _toDisplayString($setup.label("readonly", "Read-only")), 1 /* TEXT */)
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("label", null, _toDisplayString($setup.label("name", "Name")), 1 /* TEXT */),
            _createElementVNode("input", {
              type: "text",
              class: "form-control",
              value: $props.sourceName,
              disabled: ""
            }, null, 8 /* PROPS */, _hoisted_12)
          ]),
          ($props.showDescriptionNote)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createElementVNode("label", null, _toDisplayString($setup.label("description", "Description")), 1 /* TEXT */),
                _createElementVNode("textarea", _hoisted_14, _toDisplayString($props.sourceDescription), 1 /* TEXT */)
              ]))
            : _createCommentVNode("v-if", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.fields, (field) => {
            return (_openBlock(), _createElementBlock("div", {
              key: `source-${field.key}`,
              class: _normalizeClass($setup.sourceFieldClass(field))
            }, [
              _createElementVNode("label", null, _toDisplayString(field.label), 1 /* TEXT */),
              (field.type === 'textarea' || field.type === 'json')
                ? (_openBlock(), _createElementBlock("textarea", _hoisted_15, _toDisplayString(field.sourceValue), 1 /* TEXT */))
                : (_openBlock(), _createElementBlock("input", {
                    key: 1,
                    type: "text",
                    class: "form-control",
                    value: field.sourceValue,
                    disabled: ""
                  }, null, 8 /* PROPS */, _hoisted_16))
            ], 2 /* CLASS */))
          }), 128 /* KEYED_FRAGMENT */))
        ])
      ]),
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("h2", null, _toDisplayString($setup.label("translationTitle", "English (Translation)")), 1 /* TEXT */),
          _createElementVNode("span", _hoisted_19, _toDisplayString($props.sourceType), 1 /* TEXT */),
          _createElementVNode("span", {
            class: _normalizeClass(["badge", `badge-${$props.translationPersisted ? $props.translationStatus : 'draft'}`])
          }, _toDisplayString($props.translationPersisted ? $props.translationStatus : $setup.label("statusNew", "New")), 3 /* TEXT, CLASS */)
        ]),
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("label", _hoisted_22, _toDisplayString($setup.label("name", "Name")) + " *", 1 /* TEXT */),
            _withDirectives(_createElementVNode("input", {
              id: "content_name",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($setup.translationName) = $event)),
              type: "text",
              name: "content[name]",
              class: "form-control",
              required: ""
            }, null, 512 /* NEED_PATCH */), [
              [_vModelText, $setup.translationName]
            ])
          ]),
          ($props.showDescriptionNote)
            ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                _createElementVNode("label", null, _toDisplayString($setup.label("description", "Description")), 1 /* TEXT */),
                _createElementVNode("p", _hoisted_24, _toDisplayString($setup.label("descriptionNote", "Descriptions are managed per-book.")), 1 /* TEXT */)
              ]))
            : _createCommentVNode("v-if", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.fields, (field) => {
            return (_openBlock(), _createElementBlock("div", {
              key: `translation-${field.key}`,
              class: _normalizeClass($setup.translationFieldClass(field))
            }, [
              _createElementVNode("label", {
                for: `content_data_${field.key}`
              }, _toDisplayString(field.label), 9 /* TEXT, PROPS */, _hoisted_25),
              (field.type === 'json')
                ? (_openBlock(), _createBlock($setup["JsonFieldInput"], {
                    key: 0,
                    "input-id": `content_data_${field.key}`,
                    "input-name": `content[data][${field.key}]`,
                    "model-value": $setup.fieldValues[field.key],
                    rows: field.rows || 4,
                    "onUpdate:modelValue": $event => ($setup.fieldValues[field.key] = $event),
                    onValidityChange: $event => ($setup.onJsonValidityChange(field.key, $event))
                  }, null, 8 /* PROPS */, ["input-id", "input-name", "model-value", "rows", "onUpdate:modelValue", "onValidityChange"]))
                : (field.type === 'textarea')
                  ? _withDirectives((_openBlock(), _createElementBlock("textarea", {
                      key: 1,
                      id: `content_data_${field.key}`,
                      "onUpdate:modelValue": $event => (($setup.fieldValues[field.key]) = $event),
                      name: `content[data][${field.key}]`,
                      class: "form-control",
                      rows: "3"
                    }, null, 8 /* PROPS */, _hoisted_26)), [
                      [_vModelText, $setup.fieldValues[field.key]]
                    ])
                  : _withDirectives((_openBlock(), _createElementBlock("input", {
                      key: 2,
                      id: `content_data_${field.key}`,
                      "onUpdate:modelValue": $event => (($setup.fieldValues[field.key]) = $event),
                      name: `content[data][${field.key}]`,
                      type: "text",
                      class: "form-control"
                    }, null, 8 /* PROPS */, _hoisted_27)), [
                      [_vModelText, $setup.fieldValues[field.key]]
                    ])
            ], 2 /* CLASS */))
          }), 128 /* KEYED_FRAGMENT */)),
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("label", _hoisted_29, _toDisplayString($setup.label("status", "Status")), 1 /* TEXT */),
            _withDirectives(_createElementVNode("select", {
              id: "content_status",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($setup.selectedStatus) = $event)),
              name: "content[status]",
              class: "form-control"
            }, [
              _createElementVNode("option", _hoisted_30, _toDisplayString($setup.label("statusDraft", "Draft")), 1 /* TEXT */),
              _createElementVNode("option", _hoisted_31, _toDisplayString($setup.label("statusPendingReview", "Pending Review")), 1 /* TEXT */),
              _createElementVNode("option", _hoisted_32, _toDisplayString($setup.label("statusPublished", "Published")), 1 /* TEXT */)
            ], 512 /* NEED_PATCH */), [
              [_vModelSelect, $setup.selectedStatus]
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_33, [
      _createElementVNode("a", {
        href: $props.cancelUrl,
        class: "btn btn-secondary"
      }, _toDisplayString($setup.label("cancel", "Cancel")), 9 /* TEXT, PROPS */, _hoisted_34),
      _createElementVNode("button", _hoisted_35, [
        _cache[2] || (_cache[2] = _createElementVNode("i", { class: "fa-solid fa-floppy-disk" }, null, -1 /* CACHED */)),
        _createTextVNode(" " + _toDisplayString($setup.label("save", "Save Translation")), 1 /* TEXT */)
      ]),
      _createElementVNode("button", _hoisted_36, _toDisplayString($setup.label("saveAndSubmit", "Save & Submit for Review")), 1 /* TEXT */)
    ])
  ], 40 /* PROPS, NEED_HYDRATION */, _hoisted_1))
}